import {
  AppBar,
  Button,
  Grid,
  IconButton,
  Toolbar,
  Backdrop,
  CircularProgress,
  Menu,
  MenuItem,
  Modal,
  Dialog,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  AccountBox,
  ArrowDropDown,
  MenuBook,
  GetApp,
} from "@material-ui/icons";
import PropTypes from "prop-types";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./style.scss";
import CloseIcon from "@material-ui/icons/Close";

import TranslateIcon from "@material-ui/icons/Translate";
import { isMobileOnly } from "react-device-detect";
import { useTranslation } from "react-i18next";
import { Document, Page, pdfjs, Outline } from "react-pdf";

import BusLogo from "../../assets/front-of-bus.png";
import CustomSnackBar from "../../containers/OperatorConfig/SnackBar";
import auth from "../../utils/auth";
import AccountModal from "./accountModal";
import pdf from "../../assets/pdf/User_Manual.pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const ResponsiveAppbar = (props) => {
  const { t, i18n } = useTranslation();
  const { showSideBar, setShowSideBar, lists, redirect, logout } = props;
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [accModalOpen, setAccModalOpen] = useState(false);
  const [manualModalOpen, setManualModalOpen] = useState(false);
  const notiNum = 4;
  const [msg, setMsg] = useState({ show: false, type: "success", msg: "" });

  const handleLogout = () => {
    setAnchorEl(null);
    auth.logout();
  };
  const handleLanguageChange = () => {
    if (i18n.language === "zh") {
      i18n.changeLanguage("en");
      localStorage.setItem("lang", "en");
    } else {
      i18n.changeLanguage("zh");
      localStorage.setItem("lang", "zh");
    }
    // window.location.reload();
  };
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleAccModal = () => {
    setAnchorEl(null);
    setAccModalOpen(true);
  };

  const handleManualModal = () => {
    setAnchorEl(null);
    setManualModalOpen(true);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAccModalOpen(false);
  };

  return (
    <AppBar
      style={{
        height: "64px",
        zIndex: 9999,
        position: "fixed",
        color: "primary",
      }}
    >
      <Toolbar>
        <Grid container style={{ height: "100%" }}>
          <Grid
            item
            md={8}
            xs={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <IconButton
              edge="start"
              onClick={() => {
                setShowSideBar(!showSideBar);
              }}
            >
              <MenuIcon style={{ color: "#fff" }} />
            </IconButton>
            <div className="logo-container">
              <img src={BusLogo} width={18} alt="" />
              <span className="item-text">
                {isMobileOnly && t("網上管理平台Short")}
                {!isMobileOnly &&
                  `${t("網上管理平台")} - ${t("專線小巴實時到站系統")}`}
              </span>
            </div>
            {/* <IconButton
              style={{ position: "relative" }}
              onClick={() => {
                setShowMessageDialog(!showMessageDialog);
              }}
              onBlur={() => {
                setShowMessageDialog(false);
              }}
            >
              <Notifications style={{ color: "#fff" }} />
              {notiNum > 0 && <NotiNumberIcon notiNum={notiNum} />}
              {showMessageDialog && <MessageDialog />}
            </IconButton> */}
          </Grid>
          <Grid
            item
            md={4}
            xs={6}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            {/* {lists.map((button) => {
              return (
                <div
                  style={{
                    marginLeft: "8px",
                    marginRight: "8px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    position: "relative",
                    height: "100%",
                  }}
                >
                  <Button
                    onClick={() => {
                      redirect(button.link, button.name);
                    }}
                  >
                    {button.whiteIcon}
                    <span
                      className="item-text"
                      style={{ marginLeft: 4, color: "white" }}
                    >
                      {button.text}
                    </span>
                  </Button>
                  {button.isActive && (
                    <span
                      style={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        backgroundColor: "#fff",
                        width: "100%",
                        height: "5px",
                      }}
                    />
                  )}
                </div>
              );
            })} */}
            <Button onClick={handleLanguageChange}>
              <TranslateIcon style={{ color: "#fff" }} />
            </Button>
            {logout &&
              logout[0] &&
              logout.map((button) => {
                return (
                  <div
                    key="logout"
                    style={{
                      marginLeft: "8px",
                      marginRight: "8px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "relative",
                      height: "100%",
                    }}
                  >
                    <div>
                      <Button
                        aria-controls="simple-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                      >
                        <span
                          className="item-text"
                          style={{
                            marginLeft: 4,
                            color: "white",
                            textTransform: "none",
                          }}
                        >
                          {localStorage.getItem("username") || "用戶"}
                        </span>
                        <ArrowDropDown style={{ color: "white" }} />
                      </Button>
                      <Menu
                        id="simple-menu"
                        style={{ zIndex: 9999 }}
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                      >
                        <MenuItem onClick={handleAccModal}>
                          {/* {t("帳戶資料")} */}
                          {/* <Button onClick={handleAccModal}> */}
                          <AccountBox style={{ color: "#333" }} />
                          <span className="item-text" style={{ marginLeft: 4 }}>
                            {t("帳戶資料")}
                          </span>
                          {/* </Button> */}
                        </MenuItem>
                        <MenuItem onClick={handleManualModal}>
                          {/* {t("帳戶資料")} */}
                          {/* <Button onClick={handleAccModal}> */}
                          <MenuBook style={{ color: "#333" }} />
                          <span className="item-text" style={{ marginLeft: 4 }}>
                            {t("user-manual")}
                          </span>
                          {/* </Button> */}
                        </MenuItem>
                        <MenuItem onClick={handleLogout}>
                          {/* <Button onClick={handleLogout}> */}
                          {button.blackIcon}
                          <span className="item-text" style={{ marginLeft: 4 }}>
                            {t(button.text)}
                          </span>
                          {/* </Button> */}
                        </MenuItem>
                      </Menu>
                    </div>

                    {button.isActive && (
                      <span
                        style={{
                          position: "absolute",
                          bottom: 0,
                          left: 0,
                          backgroundColor: "#fff",
                          width: "100%",
                          height: "5px",
                        }}
                      />
                    )}
                  </div>
                );
              })}
            <AccountModal
              open={accModalOpen}
              setOpen={setAccModalOpen}
              username={localStorage.getItem("username")}
              setMsg={setMsg}
            />
            <UserManualModal
              open={manualModalOpen}
              setOpen={setManualModalOpen}
              username={localStorage.getItem("username")}
              setMsg={setMsg}
            />
          </Grid>
        </Grid>
        <CustomSnackBar msg={msg} setMsg={setMsg} />
      </Toolbar>
    </AppBar>
  );
};

const UserManualModal = ({ open, setOpen, username, setMsg }) => {
  const [numPages, setNumPages] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const { t, i18n } = useTranslation();

  const onDocumentLoadSuccess = ({ numPages }) => {
    setNumPages(numPages);
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      style={{ marginTop: 48 }}
      fullWidth
      maxWidth="lg"
    >
      <DialogTitle onClose={handleClose}>
        <Grid item xs={10}>
          {`${t("user-manual")}`}
          <a href={pdf} download="OMP_User_Manual.pdf">
            <IconButton>
              <GetApp />
            </IconButton>
          </a>
        </Grid>
        <Grid item xs={1}>
          <IconButton
            aria-label="close"
            style={{
              position: "absolute",
              right: 4,
              top: 4,
              color: "grey",
            }}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </Grid>
      </DialogTitle>
      <DialogContent style={{ padding: 0 }}>
        <Document file={pdf} onLoadSuccess={onDocumentLoadSuccess}>
          <Outline />
          {Array.from(new Array(numPages), (el, index) => (
            <Page
              key={`page_${index + 1}`}
              pageNumber={index + 1}
              width={720}
            />
          ))}
        </Document>
      </DialogContent>
    </Dialog>
  );
};

const NotiNumberIcon = (props) => {
  const { notiNum } = props;
  return (
    <div
      style={{
        backgroundColor: "#ff5f58",
        color: "#fff",
        borderRadius: "50%",
        height: "24px",
        width: "24px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <span style={{ fontSize: "16px" }}>{notiNum}</span>
    </div>
  );
};

NotiNumberIcon.propTypes = {
  notiNum: PropTypes.number,
};

NotiNumberIcon.defaultProps = {
  notiNum: 0,
};

ResponsiveAppbar.propTypes = {
  showSideBar: PropTypes.bool,
  setShowSideBar: PropTypes.func.isRequired,
  lists: PropTypes.arrayOf(PropTypes.number),
  redirect: PropTypes.func,
};

ResponsiveAppbar.defaultProps = {
  showSideBar: false,
  lists: [],
  redirect: () => {},
};

export default ResponsiveAppbar;
